export default __webpack_public_path__ + "static/media/carpet-cleaning.e9604d53.png";